import { Divider, useMediaQuery } from "@mui/material";
import moment from "moment";
import { CrossIcon, EditIconCard } from "../../../assets/images";
import { MuiRightDrawer } from "../../../builderPackage/components";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { faintGray, mobilenoblack, secondaryTextGray } from "../../../theme/palette";
import { systemColor } from "../../../theme/systemColor";
import { dateFormate } from "../../../utils/utils";
// import { CrossIcon } from "../../spareIssue/assets";
import { DocFileIconSVG, DownloadIconSVG, ImageFileIconSVG, PDFFileIconSVG } from "../../spareParts/purchaseRequistion/assets/customIcons";
import { getOtherDetailsAPIGet } from "../apiCall";
import { StockTransferRequisitionAPIKeys } from "../entity";
import { StatusProgressComponent } from "./stepperComponent";
import ViewAddedParts from "./viewAddedParts";
var renderIcon = function (contentType) {
    var type = contentType === null || contentType === void 0 ? void 0 : contentType.split('.')[1];
    switch (type) {
        case 'png':
            return /*#__PURE__*/ React.createElement(ImageFileIconSVG, {
                sx: {
                    width: 40,
                    height: 40,
                    fontSize: 40,
                    color: faintGray
                }
            });
        case 'jpg':
            return /*#__PURE__*/ React.createElement(ImageFileIconSVG, {
                sx: {
                    width: 40,
                    height: 40,
                    fontSize: 40,
                    color: faintGray
                }
            });
        case 'jpeg':
            return /*#__PURE__*/ React.createElement(ImageFileIconSVG, {
                sx: {
                    width: 40,
                    height: 40,
                    fontSize: 40,
                    color: faintGray
                }
            });
        case 'pdf':
            return /*#__PURE__*/ React.createElement(PDFFileIconSVG, {
                sx: {
                    width: 40,
                    height: 40,
                    fontSize: 40,
                    color: faintGray
                }
            });
        case 'doc':
            return /*#__PURE__*/ React.createElement(DocFileIconSVG, {
                sx: {
                    width: 40,
                    height: 40,
                    fontSize: 40,
                    color: faintGray
                }
            });
        case 'docx':
            return /*#__PURE__*/ React.createElement(DocFileIconSVG, {
                sx: {
                    width: 40,
                    height: 40,
                    fontSize: 40,
                    color: faintGray
                }
            });
        default:
            return null;
    }
};
export var MoreDetails = function (props) {
    var _rowData$row, _rowData$row2;
    var rowData = props.rowData, handleRowEditClick = props.handleRowEditClick, handleDrawerClose = props.handleDrawerClose;
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var step1 = [{
            type: FormItemTypes.ContainerItem,
            name: 'actionPanel',
            label: '',
            value: null,
            columnSize: 12,
            spacing: 0,
            marginTop: 1,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'TotalQuantity',
                    label: 'Total items',
                    value: null,
                    columnSize: 6
                }]
        }, {
            type: FormItemTypes.Custom,
            name: "AddedParts",
            containerProps: {
                padding: 0
            },
            element: ViewAddedParts,
            columnSize: 12
        }];
    var step2 = [{
            type: FormItemTypes.Custom,
            name: "StockAdjustmentRequisitionDetail",
            label: '',
            value: null,
            element: function () { /*#__PURE__*/ return React.createElement(StatusProgressComponent, {
                data: rowData
            }); },
            columnSize: 12
        }];
    var step3 = [{
            type: FormItemTypes.Typography,
            name: "CreatedBy",
            label: 'Created by',
            value: null,
            valueGetter: function (data) {
                var _data$RecordedByGiven, _data$RecordedByFamil;
                return data.RecordedByGivenName || data.RecordedByFamilyName ? "".concat((_data$RecordedByGiven = data.RecordedByGivenName) !== null && _data$RecordedByGiven !== void 0 ? _data$RecordedByGiven : '', " ").concat((_data$RecordedByFamil = data.RecordedByFamilyName) !== null && _data$RecordedByFamil !== void 0 ? _data$RecordedByFamil : '').trim() : '-';
            },
            columnSize: 6,
            labelTypographyProps: {
                color: mobilenoblack
            }
        }, {
            type: FormItemTypes.Typography,
            name: "CreatedOn",
            label: 'Created date',
            valueGetter: function (data) {
                var _dateFormate;
                return (_dateFormate = dateFormate(data === null || data === void 0 ? void 0 : data.CreatedOn)) !== null && _dateFormate !== void 0 ? _dateFormate : '-';
            },
            value: null,
            columnSize: 6,
            labelTypographyProps: {
                color: mobilenoblack
            }
        }, {
            type: FormItemTypes.Custom,
            name: "",
            columnSize: 12,
            element: function () { /*#__PURE__*/ return React.createElement(Divider, {
                style: {
                    width: '100%'
                }
            }); }
        }, {
            type: FormItemTypes.List,
            name: "Attachments",
            label: 'Attachments',
            value: null,
            columnSize: 12,
            variant: 'compact',
            columns: [{
                    field: 'Icon',
                    maxWidth: 40,
                    renderCell: function (params) { return renderIcon(params.row.Name); }
                }, {
                    field: 'Name',
                    flex: 1
                }, {
                    field: 'Size',
                    width: 80,
                    valueFormatter: function (value) { return "".concat(Math.round(value / 1000), " KB"); }
                }],
            disableCheckboxSelection: true,
            rowHeight: 72
        }];
    var tabs = [{
            id: '0',
            label: 'Items',
            elements: step1
        }, {
            id: '1',
            label: 'Status Progress',
            elements: step2
        }, {
            id: '2',
            label: 'Other',
            elements: step3
        }];
    var moreDetailsFormData = [{
            type: FormItemTypes.ContainerItem,
            name: 'header',
            label: '',
            flexDirection: 'row',
            columnSize: 12,
            marginTop: IS_DESKTOP ? 8 : 0,
            justifyContent: 'space-between',
            padding: '20px 0px',
            spacing: 0,
            rowSpacing: 3,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'header',
                    label: 'More Details',
                    columnSize: 11,
                    labelTypographyProps: {
                        variant: 'h1',
                        color: mobilenoblack,
                        paddingX: '24px'
                    }
                }, {
                    type: FormItemTypes.IconButton,
                    name: 'Close',
                    columnSize: 1,
                    size: 'large',
                    children: /*#__PURE__*/ React.createElement("img", {
                        id: "crossIconBtn",
                        color: secondaryTextGray,
                        src: CrossIcon,
                        onClick: handleDrawerClose
                    }),
                    sx: {
                        padding: ' 0px 24px 0px 0px'
                    }
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'actionPanel',
            label: '',
            value: null,
            columnSize: 12,
            spacing: 0,
            bgcolor: '#EFF2F5',
            padding: 2,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'DOC NUMBER',
                    label: 'DOC NUMBER',
                    value: null,
                    columnSize: 6,
                    children: (rowData === null || rowData === void 0 || (_rowData$row = rowData.row) === null || _rowData$row === void 0 ? void 0 : _rowData$row.DocumentCode) || '',
                    paddingLeft: 3,
                    labelTypographyProps: {
                        variant: 'caption',
                        color: systemColor.lightGrey,
                        paddingLeft: 3
                    }
                }, {
                    type: FormItemTypes.Typography,
                    name: 'DOC DATE',
                    label: 'DOC DATE',
                    value: null,
                    columnSize: 6,
                    children: moment(rowData === null || rowData === void 0 || (_rowData$row2 = rowData.row) === null || _rowData$row2 === void 0 ? void 0 : _rowData$row2.DocumentCode).format('DD MMM YYYY • h:mm A') || '',
                    display: "flex",
                    justifyContent: "flex-end",
                    paddingRight: 1,
                    labelTypographyProps: {
                        display: 'flex',
                        justifyContent: 'flex-end',
                        variant: 'caption',
                        color: systemColor.lightGrey,
                        paddingRight: 1
                    }
                }]
        }, {
            type: FormItemTypes.Tabs,
            name: 'Tabs',
            tabs: tabs,
            variant: 'fullWidth',
            displayExpr: 'label',
            columnSize: 12,
            tabPanelProps: {
                sx: {
                    px: 3,
                    pb: '90px'
                }
            }
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            position: 'fixed',
            width: {
                xs: '100%',
                sm: '600px'
            },
            justifyContent: 'end',
            bottom: 0,
            right: 0,
            spacing: 0,
            p: '16px 24px 24px 24px!important',
            columnGap: 2,
            bgcolor: 'white',
            borderTop: "1px solid ".concat(faintGray),
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'editButton',
                    value: null,
                    children: 'Edit',
                    columnSize: 0,
                    onClick: function () { return handleRowEditClick(rowData === null || rowData === void 0 ? void 0 : rowData.id); },
                    startIcon: /*#__PURE__*/ React.createElement("img", {
                        id: "moreDetail-edit-img",
                        src: EditIconCard,
                        alt: "Error"
                    }),
                    sx: {
                        background: 'none',
                        border: '1px solid #DEE4EB',
                        color: "".concat(systemColor.darkGrey)
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: 'DownloadPDF',
                    value: null,
                    children: 'Download as PDF',
                    columnSize: 0,
                    startIcon: /*#__PURE__*/ React.createElement(DownloadIconSVG, {
                        sx: {
                            width: 20,
                            height: 20,
                            color: systemColor.primary
                        }
                    }),
                    sx: {
                        background: 'none',
                        border: "1px solid ".concat(systemColor.primary)
                    }
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiRightDrawer, {
        id: "filter-drawer",
        anchor: "right",
        openDrawer: props.openDrawer,
        onClose: props.handleDrawerClose,
        sx: {
            width: {
                xs: '100%',
                sm: '600px'
            }
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: moreDetailsFormData,
        mode: "edit",
        getRequest: {
            id: rowData === null || rowData === void 0 ? void 0 : rowData.id
        },
        getFormAPI: getOtherDetailsAPIGet,
        getKey: StockTransferRequisitionAPIKeys.attachmentList
    })));
};
